export const UserRole = {
  ADMIN: 'admin',
  RESELLER: 'reseller'
} as const;

export interface IRole {
  _id: string;
  name: string;
  isDeleted: string;
  createdAt: Date;
  updatedAt: Date;
}
